/* eslint-disable no-unused-vars */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance, apiInstanceFetch } from "../../component/api/axiosApi";
import jwt_decode from "jwt-decode";
import { SetDevKey, setToken } from "../../util/setAuth";
import { secretKey } from "../../util/config";
import { DangerRight, Success } from "../../component/api/toastServices";

const initialState = {
  admin: {},
  isAuth: false,
  isLoading: false,
};

export const signUp = createAsyncThunk("admin/signUp", async (payload) => {
  return apiInstance.post("admin/signUp", payload);
});
export const updateCode = createAsyncThunk(
  "admin/updateCode",
  async (payload) => {
    return apiInstance.patch("admin/updateCode", payload);
  }
);

export const login = createAsyncThunk("admin/login", async (payload) => {
  return apiInstance.post("admin/login", payload);
});
export const resetPassword = createAsyncThunk("admin/reset-password-email", async (payload) => {
  return apiInstance.post("admin/reset-password-email", payload);
});

export const getAdmin = createAsyncThunk("admin/getProfile", async () => {
  return apiInstanceFetch.get("admin/getProfile");
});

export const updateAdmin = createAsyncThunk("admin/update", async (payload) => {
  return apiInstance.post("admin/update", payload);
});

export const updateAdminPassword = createAsyncThunk(
  "admin/updateAdminPassword",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("admin/updateAdminPassword", payload);

      // If status code is 422 (Unprocessable Entity), reject the promise
      if (response.status === 422) {
        return rejectWithValue(response.data);  // Reject with the response data
      }

      return response.data;  // Return success data
    } catch (error) {
      // Reject for other errors, such as network issues or server errors
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    setOldAdmin(state, action) {
      let token = action.payload;
      state.admin = token;
      state.isAuth = true;
      SetDevKey(secretKey);
      setToken(token);
    },
    logout(state, action) {
      localStorage.removeItem("token");
      localStorage.removeItem("admin_");
      localStorage.removeItem("key");
      localStorage.removeItem("isAuth");
      state.admin = {};
      state.isAuth = false;
    },
    clearAuthState(state) {
      state.admin = {};
      state.isAuth = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(login.fulfilled, (state, action) => {
      if (action.payload && action.payload.status !== false) {
        // console.log(action.payload);
        let token_ = action.payload.token;
        state.flag = action.payload.flag;
        state.admin = token_;
        state.isAuth = true;
        SetDevKey(secretKey);
        setToken(action.payload.token);
        // console.log("action.payload.token", action.payload.token);
        localStorage.setItem("type", action.payload.user.type);
        localStorage.setItem("token", token_);
        apiInstance.defaults.headers.common["Authorization"] = `Bearer ${token_}`;
        localStorage.setItem("key", secretKey ? secretKey : undefined);
        localStorage.setItem("isAuth", true);
        Success("Login successfully");
      }
      state.isLoading = false;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(resetPassword.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(resetPassword.fulfilled, (state, action) => {
      if (action.payload && action.payload.status !== false) {
        Success(action.payload?.message);
        setTimeout(
          () => {
            window.location.href = "/";

          }, 3000
        )
      }
      else {
        DangerRight(action.payload?.message);
      }
      state.isLoading = false;
    });
    builder.addCase(resetPassword.rejected, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(getAdmin.fulfilled, (state, action) => {
      state.isLoading = false;
      state.admin = {
        ...state.admin,
        id: action.payload?.admin?.id,
        flag: action.payload?.admin?.flag,
        name: action.payload?.admin?.name,
        email: action.payload?.admin?.email,
        image: action.payload?.admin?.image,
        type: action.payload?.admin?.type,
      };
      localStorage.setItem('type', action.payload?.admin?.type);
    });

    builder.addCase(getAdmin.rejected, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(updateAdmin.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(updateAdmin.fulfilled, (state, action) => {
      state.isLoading = false;
      state.admin = {
        ...state.admin,
        name: action.payload?.admin?.name,
        email: action.payload?.admin?.email,
        image: action.payload?.admin?.image,
      };
      state.isLoading = false;
      Success("Admin Updated Successfully");
    });

    builder.addCase(updateAdmin.rejected, (state, action) => {
      state.isLoading = false;
      DangerRight("Failed to update password: " + (action.payload?.message || "Unknown error"));

    });

    builder.addCase(updateAdminPassword.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(updateAdminPassword.fulfilled, (state, action) => {
      state.isLoading = false;
      Success("Admin Password Updated Successfully");

      setTimeout(() => {
        // action.asyncDispatch(authSlice.actions.clearAuthState());

        localStorage.removeItem("token");
        localStorage.removeItem("key");
        localStorage.removeItem("isAuth");

        setToken();
        SetDevKey();

        window.location.href = "/";
      }, 3000);
      state.admin = {};
      state.isAuth = false;
    });

    builder.addCase(updateAdminPassword.rejected, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(signUp.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(signUp.fulfilled, (state, action) => {
      state.isLoading = false;
      if (action?.payload?.status) {
        Success("Admin Create Successfully");
        setTimeout(
          () => {
            window.location.href = "/";

          }, 3000
        )
      }
    });
    builder.addCase(signUp.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateCode.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(updateCode.fulfilled, (state, action) => {
      state.isLoading = false;
      Success("Code Update Successfully");
      setTimeout(() => {
        window.location.href = "/";
      }, 10);
    });
    builder.addCase(updateCode.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});
export default authSlice.reducer;
export const { setOldAdmin, logout, clearAuthState } = authSlice.actions;
